function random(min: number, max: number) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

export const getRandomRows = (length: number, count: number): number[] => {
  const output: number[] = [];
  let randRow: number;
  for (let i = 0; i < count; i++) {
    randRow = random(0, length - 1);
    while(output.indexOf(randRow) >= 0) {
      randRow = random(0, length - 1);
    }
    output.push(randRow);
  }
  return output;
}